﻿import './recipeDetail.less'

const InitVideos = () => {
    let video = videojs("RecipeVideo");
    video.ready(function () {
        // Sets volume to 50%
        this.volume(0.10);
    });
    video.on('ended', function () {
        // Show the poster component
        this.posterImage.show();
        this.removeClass('vjs-has-started');

    });
    video.on('play', function () {
        // Show the poster component
        this.posterImage.hide();
    
        document.querySelector("#RecipeVideo").classList.add("vjs-has-started");
    });

    const poster = document.querySelector("#RecipeVideo");

    if (poster) {
        const posterUrl = poster.getAttribute("poster");

        if (posterUrl) {
            (async () => {
                try {
                    const { width, height } = await getImageDimensions(posterUrl);
                    //console.log(`Width: ${width}, Height: ${height}`);

                    let aspectRatio = parseInt(width) / parseInt(height);
                    poster.style.aspectRatio = aspectRatio;
                } catch (error) {
                    console.error(error);
                }
            })();

            let elements = document.querySelectorAll('video');
            let isScrolling = null;

            // Listen for scroll events
            window.addEventListener('scroll', function (event) {

                // Clear our timeout throughout the scroll
                window.clearTimeout(isScrolling);

                // Set a timeout to run after scrolling ends
                isScrolling = setTimeout(function () {

                    // Run the callback
                    checkPosition();

                }, 66);

            }, false);

            const checkPosition = () => {
                elements = document.querySelectorAll('video');
                elements.forEach((video) => {
                    let position = video.getBoundingClientRect();

                    // checking whether fully visible
                    let shouldPlay = false;

                    if (position.top >= 0 && position.bottom <= window.innerHeight) {
                        shouldPlay = true;
                    } else if (position.top < window.innerHeight && position.bottom >= 0) {
                        shouldPlay = true;
                    }
                    // console.log("shouldPlay:: ", shouldPlay, " :: playing? :: ", video);
                    if (!shouldPlay && video.parentElement.classList.contains("vjs-playing")) {
                        video.pause();
                    } else if (shouldPlay && video.parentElement.classList.contains("vjs-paused") && video.parentElement.classList.contains("vjs-has-started")   ){
                        video.play();
                    }
                });
            }
        }
    }
}



async function getImageDimensions(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
        img.onerror = () => reject(new Error('Failed to load image'));
        img.src = url;
    });
}

if (document.readyState !== 'loading') {
    InitVideos();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        InitVideos();
    });
}